import UploadArea from './UploadArea'
import UploadItem from './UploadItem'

const ImageUpload = ({ images = [], onChange, max = 9, onPreview }) => {
  const handleFilesSelected = (url, file, index, isUploading) => {
    if (isUploading) {
      const id = `temp-${Date.now()}-${index}`
      file.__tempId = id

      onChange((prev) => [
        ...prev,
        {
          id,
          name: file.name,
          uploading: true
        }
      ])
      return
    }

    onChange((prev) =>
      prev.map((img) =>
        img.id === file.__tempId ? { ...img, url, uploading: false } : img
      )
    )
  }

  const handleRemove = (index) => {
    onChange((prev) => prev.filter((_, i) => i !== index))
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {images.map((img, index) => (
        <UploadItem
          key={img.id}
          image={img}
          onRemove={() => handleRemove(index)}
          onPreview={onPreview}
        />
      ))}

      {images.length < max && (
        <UploadArea
          accept="image/*"
          maxFiles={max}
          currentCount={images.length}
          onFilesSelected={handleFilesSelected}
        />
      )}
    </div>
  )
}
export default ImageUpload
